<ng-container *transloco="let t">
  @if (!showError) {
    <h1 class="title">{{ t('ui.Email verification required') }}</h1>
    <p class="description">{{ t('ui.Press Continue to proceed to verify your email address.') }}</p>
    <div class="button-container">
      <a
        [routerLink]="verificationUrl"
        class="button button-pill button-reverse"
        [ngClass]="{ disabled: callInProgress }"
        (click)="continueVerification($event)">
        {{ t('ui.Continue') }}
      </a>
    </div>
  }
  @if (showError) {
    <svg-icon src="/assets/icons/alert-circle.svg" class="alert-icon"></svg-icon>
    <div class="title">{{ t('ui.Something went wrong') }}</div>
    <p class="description">
      {{ t('ui.Your email verification code request was not processed. Please try again.') }}
    </p>
    <p class="description">{{ t('ui.If the problem persists, contact us at') }} support&#64;kumanu.com.</p>
    <div class="button-container">
      <button class="button button-pill button-reverse full-width" (click)="dismissModal()">
        {{ t('ui.Close') }}
      </button>
    </div>
  }
</ng-container>
